// extracted by mini-css-extract-plugin
module.exports = {"container":"_1YFmr","stacked":"_6s2bg","withDivider":"_7UGlX"};